export interface ExclusionPeriod {
  endDate: string | null,
  startDate: string | null,
}

export function productExclusionPeriodsOverlap (
  period: ExclusionPeriod,
  other: ExclusionPeriod,
): boolean {
  if (period.endDate && other.startDate && period.endDate <= other.startDate) {
    return false;
  }
  if (other.endDate && period.startDate && other.endDate <= period.startDate) {
    return false;
  }
  return true;
}
